import { render } from "./doo3d.vue?vue&type=template&id=6600985a&scoped=true"
import script from "./doo3d.vue?vue&type=script&lang=js"
export * from "./doo3d.vue?vue&type=script&lang=js"

import "./doo3d.vue?vue&type=style&index=0&id=6600985a&scoped=true&lang=css"

import exportComponent from "D:\\project\\weetgo\\doo3dexamples\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6600985a"]])

export default __exports__